module.exports = __webpack_public_path__ + "static/why-2c1fd5957e79cb026ecb0f9bf10b9370.svg";